module.exports = __webpack_public_path__ + "images/hero-2.jpg?bb333";